import { Experiment } from '@cian/experiments/ab';
import classNames from 'classnames';
import * as React from 'react';

import { ETabType } from '../../types/filters';
import { PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';

import * as styles from './styles.css';

interface IEntityTypeToggle {
  type: ETabType | null;
  showSaveSearchEntity: boolean;
  clickSavedSearch(): void;
  onAdvertisementsClick(): void;
  onJKClick(): void;
  onSavedSearchClick(): void;
}

export const EntityTypeToggle: React.FC<IEntityTypeToggle> = ({
  type,
  showSaveSearchEntity,
  clickSavedSearch,
  onAdvertisementsClick,
  onJKClick,
  onSavedSearchClick,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['filters']}>
        <div className={styles['row']}>
          <ul className={styles['favorites-type']}>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
              <li
                onClick={onAdvertisementsClick}
                className={classNames(
                  styles['favorites-type-item'],
                  (type === ETabType.Аdvertisements || type === null) && styles['favorites-type-item--active'],
                )}
              >
                Объявления
              </li>
            </Experiment>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="A" default>
              <li
                onClick={onAdvertisementsClick}
                className={classNames(
                  styles['favorites-type-item'],
                  type !== ETabType.JK && styles['favorites-type-item--active'],
                )}
              >
                Объявления
              </li>
            </Experiment>
            <li
              onClick={onJKClick}
              className={classNames(
                styles['favorites-type-item'],
                type === ETabType.JK && styles['favorites-type-item--active'],
              )}
            >
              ЖК
            </li>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
              <li
                onClick={onSavedSearchClick}
                className={classNames(
                  styles['favorites-type-item'],
                  type === ETabType.SavedSearches && styles['favorites-type-item--active'],
                )}
              >
                Поиски
              </li>
            </Experiment>
            <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="A" default>
              {showSaveSearchEntity && (
                <li onClick={clickSavedSearch} className={styles['favorites-type-item']} role="link">
                  Поиски
                </li>
              )}
            </Experiment>
          </ul>
        </div>
      </div>
    </div>
  );
};
